export class ApplicationSettings {

	constructor(public title, public navigateBack = false, public navigateToSettings = false) {

	}
}